import { GroupModelType } from '@teinor/erp/types/company/userInner/group'
import ModalCEGroupEmployee from './ModalCEGroupEmployee'
import { useLocation } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface GroupEmployeesProps extends ComponentWithPermissions { }

const GroupEmployees: React.FC<GroupEmployeesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('employeesGroups', 'Grupos de empleados'),
        newText: t('newGroup', 'Nuevo grupo'),
    }

    return (
        <BaseScreenTable TableComponent={TableGroupEmployees} CreateModalComponent={ModalCEGroupEmployee} EditModalComponent={ModalCEGroupEmployee} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableGroupEmployeesProps extends TableComponentProps { }

const TableGroupEmployees: React.FC<TableGroupEmployeesProps> = ({ setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const location = useLocation().pathname
    const columns: ColumnTableSchema<GroupModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'listing',
            dataKey: 'listing',
            label: t('listing', 'Listado'),
            width: 100,
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={55} />,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
    ]
    return (
        <TwinTableLink name='groupEmployees' columns={columns} getDataFrom='/api/app/group/getAllGroups' onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} createRowDataLink={[location, ['$id']]}/>
    )
}

export default GroupEmployees